import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'

function ShipInstructionsBarV2({ shipMethod, shipInstructions }) {
  if (!shipMethod && !shipInstructions) return null
  return (
    <Box sx={{
      border: '1px solid #e7e7e7',
      borderRadius: 2,
      p: 2,
      backgroundColor: '#fff',
    }}>
      <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.95rem', color: '#262626', fontWeight: 700, mb: 1 }}>
        Ship Instructions
      </Typography>
      <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626' }}>
        <Box component='span' sx={{ fontWeight: 600 }}>Method:</Box>
        {' '}{shipMethod}
        {shipInstructions && (
          <>
            {' '}&bull;{' '}{shipInstructions}
          </>
        )}
      </Typography>
    </Box>
  )
}

ShipInstructionsBarV2.propTypes = {
  shipMethod: PropTypes.string,
  shipInstructions: PropTypes.string,
}

export default ShipInstructionsBarV2
